@if (isTimerPinned == false && TotalTimer > 0 && isQuickPanelOpen == false) {
  <div fxLayout="column" fxFlex class="time_entry_sidebar_narrow" (click)="onClickPanel()">
    @if (runningEvent) {
      <div
        class="vertical-item running"
        [ngClass]="themeType?.includes('dark') ? 'border-dark' : 'border-light'"
      >
        <div class="vertical-text-time-entry">
          {{ getMatterName(runningEvent.matter_id) }}
          <br />
          {{ currentTimerHMS }}
        </div>
      </div>
    }
    @for (event of pausedEvents; track event) {
      <div
        class="vertical-item"
        [ngClass]="themeType?.includes('dark') ? 'border-dark' : 'border-light'"
      >
        <div class="vertical-text-time-entry">
          {{ getMatterName(event.matter_id) }}
          <br />
          {{ event.time }}
        </div>
      </div>
    }
  </div>
} @else {
  <div fxLayout="column" fxFlex class="time_entry_sidebar">
    <!-- PIN Timer Panel -->
    <div fxLayout="row">
      <span fxFlex></span>
      <button
        mat-icon-button
        (click)="toggleTimerPin()"
        [matTooltip]="isTimerPinned ? 'Unpin timer' : 'Pin timer'"
        matTooltipPosition="left"
      >
        <!-- <mat-icon [matTooltip]="isTimerPinned ? 'Unpin timer' : 'Pin timer'" matTooltipPosition="right">
        {{ isTimerPinned ? 'bookmark' : 'bookmark_border' }}
      </mat-icon> -->
        <img
          [src]="getPinIcon()"
          width="16"
          height="16"
          class="inline-block h-4 w-4 cursor-pointer"
          [attr.alt]="isTimerPinned ? 'Unpin timer' : 'Pin timer'"
          role="button"
        />
      </button>
    </div>
    <mat-divider cdkFocusRegionEnd></mat-divider>
    <mat-list class="quick-panel-mat-list">
      <div fxLayout="row" fxLayoutAlign="start center" class="gap-10 p-10">
        <mat-form-field
          class="searchMatter-input w-20 grow"
          appearance="outline"
          subscriptSizing="dynamic"
          [ngClass]="{ 'has-error': !searchMatterValue }"
        >
          <mat-label>Matters</mat-label>
          <mat-chip-grid #chipList aria-label="Matter selection" id="chiplist">
            @for (matterdata of mattername; track matterdata) {
              <mat-chip-row
                (removed)="remove(matterdata)"
                class="mat-chips-selected h-[46px] leading-[14px]"
              >
                {{ matterdata | slice: 0 : 20 }}
                @if (matterdata.length > 25) {
                  ...
                }
                <button matChipRemove class="canclebutton">
                  <mat-icon style="font-size: 18px !important">cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              matInput
              type="search"
              class="form-control"
              name="Matter"
              [(ngModel)]="searchMatterValue"
              (keydown.Tab)="datashow($event)"
              #MatterInput1
              [matAutocomplete]="autoMatter"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event)"
              (keyup)="onKeyUp($event)"
              [ngClass]="mattername.length > 0 ? 'hideInput' : 'showInput'"
            />
          </mat-chip-grid>
          <mat-autocomplete #autoMatter="matAutocomplete" (optionSelected)="selectedValue($event)">
            @for (data of matterlist; track data) {
              <mat-option
                class="mat-option_1"
                (click)="selectedmatterguid(data)"
                value="{{ data.MATTERGUID }}"
              >
                <!-- {{data.SHORTNAME}}--{{data.MATTER}} -->
                {{ data.SELECTEDDESCRIPTION }}
              </mat-option>
            }
          </mat-autocomplete>
          <mat-icon
            class="matter_icon_timeDiary cursor-pointer"
            matSuffix
            (click)="openMatterSetTimer()"
          >
            <!-- <img src="assets/icons/web_app/icon_matter_d.ico"
            matTooltip="select matter"
            matTooltipPosition="above"> -->
            <img
              src="assets/icons/web_app/Frame 36.svg"
              matTooltip="select matter"
              matTooltipPosition="above"
            />
          </mat-icon>
        </mat-form-field>
        <button
          matButton="filled"
          class="new-timer-button mat-accent shrink-0"
          (click)="addTimerMatterWise()"
        >
          New Timer
        </button>
      </div>
      <mat-divider cdkFocusRegionEnd></mat-divider>
      @if (_eventsData) {
        <span class="timer-list-wrapper">
          <!-- <mat-list-item *ngFor="let event of _eventsData"
            class="time_entry_list">
            <h3 matLine *ngIf="event.isStart">{{currentTimerHMS}}</h3>
            <h3 matLine *ngIf="!event.isStart">{{event.time}}</h3>
            <p matLine class="secondary-text listitem-text">{{event.matter_id}}</p>
            <button mat-raised-button color="primary" *ngIf="!event.isStart"
              (click)="startTimer(event.uuid)"
              mat-button class="play_btn"><i class="material-icons">play_arrow</i></button>
              <button mat-raised-button color="primary" *ngIf="event.isStart"
                (click)="stopTimer(event.uuid)"
                mat-button class="pause_btn"><i class="material-icons">pause</i></button>
                <button mat-raised-button color="primary" mat-button
                  class="pause_btn" (click)="endTimer(event.uuid)"><i
                class="material-icons">stop</i></button>
                <button mat-raised-button color="primary" mat-button
                  class="pause_btn" (click)="editTimerlocaly(event.uuid)"><i
                class="material-icons">edit</i></button>
                <mat-divider cdkFocusRegionEnd></mat-divider>
              </mat-list-item> -->
          @for (event of _eventsData; track event) {
            <mat-list-item class="time_entry_list">
              <div class="text-column">
                <span class="timer-time">
                  {{ event.isStart ? currentTimerHMS : event.time }}
                </span>
                <span class="timer-matter secondary-text listitem-text">
                  {{ event.matter_id }}
                </span>
              </div>
              <div matListItemMeta class="button-group">
                @if (!event.isStart) {
                  <button matButton="tonal" (click)="startTimer(event.uuid)" class="play_btn">
                    <i class="material-icons">play_arrow</i>
                  </button>
                }
                @if (event.isStart) {
                  <button matButton="tonal" (click)="stopTimer(event.uuid)" class="pause_btn">
                    <i class="material-icons">pause</i>
                  </button>
                }
                <button matButton="tonal" (click)="endTimer(event.uuid)" class="pause_btn">
                  <i class="material-icons">stop</i>
                </button>
                <button matButton="tonal" (click)="editTimerlocaly(event.uuid)" class="pause_btn">
                  <i class="material-icons">edit</i>
                </button>
              </div>
            </mat-list-item>
          }
        </span>
      }
    </mat-list>
  </div>
}
